import { useState } from 'react';
import { Link, NavLink } from 'react-router';
import { Logo } from './logo';
import { SubmitLink } from './submit-modal';

const NAV = [
  { to: '/', label: 'Calendar', end: true },
  { to: '/advertise', label: 'Advertise' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

type HeaderUser = { email: string; role: string } | null;

export function SiteHeader({
  user,
  isApp = false,
  siteName = 'Networking Calendar',
}: {
  user: HeaderUser;
  isApp?: boolean;
  /** This city's name — the logo's accessible name and the home link's label. */
  siteName?: string;
}) {
  const [open, setOpen] = useState(false);

  // In the native app the bottom tab bar is the nav — the top bar is just a slim,
  // safe-area-aware brand strip (no website nav / CTA / hamburger).
  if (isApp) {
    return (
      <header className="app-topbar">
        <Link to="/" className="app-topbar-logo" aria-label={`${siteName} — home`}>
          <Logo height={28} title={siteName} />
        </Link>
      </header>
    );
  }

  return (
    <header className="site-header">
      <div className="container">
        <div className="site-header-inner">
          <Link to="/" className="site-logo-link" aria-label={`${siteName} — home`}>
            <Logo height={40} title={siteName} />
          </Link>

          <nav className="site-nav" aria-label="Main">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end}>
                {item.label}
              </NavLink>
            ))}
            <Link to={user ? '/account' : '/join'} className="nav-account">
              {user ? 'Account' : 'Sign in'}
            </Link>
            <SubmitLink className="ui-btn btn-primary btn-sm nav-cta">List Your Event</SubmitLink>
          </nav>

          <div className="row header-mobile-actions">
            {/* CTA stays visible on mobile — organizer capture is the point */}
            <SubmitLink className="ui-btn btn-primary btn-sm">List Your Event</SubmitLink>
            <button
              type="button"
              className="nav-toggle"
              aria-expanded={open ? 'true' : 'false'}
              aria-controls="mobile-nav"
              aria-label={open ? 'Close menu' : 'Open menu'}
              onClick={() => setOpen((v) => !v)}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                {open ? (
                  <path
                    d="M5 5l10 10M15 5L5 15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                ) : (
                  <path
                    d="M3 5.5h14M3 10h14M3 14.5h14"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {open && (
          <nav id="mobile-nav" className="mobile-nav" aria-label="Main menu">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setOpen(false)}>
                {item.label}
              </NavLink>
            ))}
            <Link to={user ? '/account' : '/join'} onClick={() => setOpen(false)}>
              {user ? 'Account' : 'Sign in'}
            </Link>
            <SubmitLink className="mobile-nav-cta" onNavigate={() => setOpen(false)}>
              List Your Event — free
            </SubmitLink>
          </nav>
        )}
      </div>
    </header>
  );
}
